import { useAppFetcher } from '~/hooks/use-app-fetcher';
import { useState, useEffect } from 'react';
import type { action } from '~/routes/remix-api.directory.delete-directory-item';
import { DELETE_DIRECTORY_ITEM } from '~/routes/remix-api.directory.delete-directory-item';
import { fetcherIsDone } from '~/utils/fetcherHelper';
import { toast } from 'sonner';

export const useDeleteItemWithConfirm = () => {
    const [itemID, setItemID] = useState<number | undefined>(undefined);
    const deleteFetcher = useAppFetcher<{ deleteDirectoryItem?: boolean }>();

    // Confirm to delete item
    const confirmDelete = async () => {
        if (!itemID || itemID <= 0) {
            return;
        }

        deleteFetcher.submit(
            {
                ID: itemID.toString(),
            },
            {
                method: 'post',
                action: DELETE_DIRECTORY_ITEM,
            },
        );
        setItemID(undefined);
    };

    useEffect(() => {
        if (
            fetcherIsDone(deleteFetcher) &&
            deleteFetcher.data.deleteDirectoryItem === true
        ) {
            toast.success(
                'Project deleted, please allow a few minutes for results to be updated.',
            );
        }
    }, [deleteFetcher]);

    const willDelete = (itemIDToDelete: number) => {
        setItemID(itemIDToDelete);
    };

    const cancelDelete = () => {
        setItemID(undefined);
    };

    return {
        itemID,
        willDelete,
        confirmDelete,
        cancelDelete,
    };
};
